export interface ITimezone{ offset: string; country: string; name: string; timeValue?: number }

export const timezones: ITimezone[] = [
  {
    "offset": "UTC-12:00",
    "name": "International Date Line West",
    "country": "Etc/GMT+12",
  },
  {
    "offset": "UTC-11:00",
    "name": "Coordinated Universal Time-11",
    "country": "Etc/GMT+11",
  },
  {
    "offset": "UTC-10:00",
    "name": "Hawaii",
    "country": "Pacific/Honolulu",
  },
  {
    "offset": "UTC-09:00",
    "name": "Alaska",
    "country": "America/Anchorage",
  },
  {
    "offset": "UTC-08:00",
    "name": "Baja California",
    "country": "America/Santa_Isabel",
  },
  {
    "offset": "UTC-08:00",
    "name": "Pacific Time US and Canada",
    "country": "America/Los_Angeles",
  },
  {
    "offset": "UTC-07:00",
    "name": "Chihuahua, La Paz, Mazatlan",
    "country": "America/Chihuahua",
  },
  {
    "offset": "UTC-07:00",
    "name": "Arizona",
    "country": "America/Phoenix",
  },
  {
    "offset": "UTC-07:00",
    "name": "Mountain Time US and Canada",
    "country": "America/Denver",
  },
  {
    "offset": "UTC-06:00",
    "name": "Central America",
    "country": "America/Guatemala",
  },
  {
    "offset": "UTC-06:00",
    "name": "Central Time US and Canada",
    "country": "America/Chicago",
  },
  {
    "offset": "UTC-06:00",
    "name": "Saskatchewan",
    "country": "America/Regina",
  },
  {
    "offset": "UTC-06:00",
    "name": "Guadalajara, Mexico City",
    "country": "America/Mexico_City",
  },
  {
    "offset": "UTC-05:00",
    "name": "Bogota, Lima, Quito",
    "country": "America/Bogota",
  },
  {
    "offset": "UTC-05:00",
    "name": "Indiana East",
    "country": "America/Indiana/Indianapolis",
  },
  {
    "offset": "UTC-05:00",
    "name": "Eastern Time US and Canada",
    "country": "America/New_York",
  },
  {
    "offset": "UTC-04:30",
    "name": "Caracas",
    "country": "America/Caracas",
  },
  {
    "offset": "UTC-04:00",
    "name": "Atlantic Time Canada",
    "country": "America/Halifax",
  },
  {
    "offset": "UTC-04:00",
    "name": "Asuncion",
    "country": "America/Asuncion",
  },
  {
    "offset": "UTC-04:00",
    "name": "Georgetown, La Paz, Manaus",
    "country": "America/La_Paz",
  },
  {
    "offset": "UTC-04:00",
    "name": "Cuiaba",
    "country": "America/Cuiaba",
  },
  {
    "offset": "UTC-04:00",
    "name": "Santiago",
    "country": "America/Santiago",
  },
  {
    "offset": "UTC-03:30",
    "name": "Newfoundland",
    "country": "America/St_Johns",
  },
  {
    "offset": "UTC-03:00",
    "name": "Brasilia",
    "country": "America/Sao_Paulo",
  },
  {
    "offset": "UTC-03:00",
    "name": "Greenland",
    "country": "America/Godthab",
  },
  {
    "offset": "UTC-03:00",
    "name": "Cayenne, Fortaleza",
    "country": "America/Cayenne",
  },
  {
    "offset": "UTC-03:00",
    "name": "Buenos Aires",
    "country": "America/Argentina/Buenos_Aires",
  },
  {
    "offset": "UTC-03:00",
    "name": "Montevideo",
    "country": "America/Montevideo",
  },
  {
    "offset": "UTC-02:00",
    "name": "Coordinated Universal Time-2",
    "country": "Etc/GMT+2",
  },
  {
    "offset": "UTC-01:00",
    "name": "Cape Verde",
    "country": "Atlantic/Cape_Verde",
  },
  {
    "offset": "UTC-01:00",
    "name": "Azores",
    "country": "Atlantic/Azores",
  },
  {
    "offset": "UTC+00:00",
    "name": "Casablanca",
    "country": "Africa/Casablanca",
  },
  {
    "offset": "UTC+00:00",
    "name": "Monrovia, Reykjavik",
    "country": "Atlantic/Reykjavik",
  },
  {
    "offset": "UTC+00:00",
    "name": "Dublin, Lisbon, London",
    "country": "Europe/London",
  },
  {
    "offset": "UTC+00:00",
    "name": "Coordinated Universal Time",
    "country": "Etc/GMT",
  },
  {
    "offset": "UTC+01:00",
    "name": "Amsterdam, Berlin, Bern, Rome",
    "country": "Europe/Berlin",
  },
  {
    "offset": "UTC+01:00",
    "name": "Brussels, Copenhagen, Paris",
    "country": "Europe/Paris",
  },
  {
    "offset": "UTC+01:00",
    "name": "West Central Africa",
    "country": "Africa/Lagos",
  },
  {
    "offset": "UTC+01:00",
    "name": "Belgrade, Bratislava, Budapest",
    "country": "Europe/Budapest",
  },
  {
    "offset": "UTC+01:00",
    "name": "Sarajevo, Skopje, Zagreb",
    "country": "Europe/Warsaw",
  },
  {
    "offset": "UTC+01:00",
    "name": "Windhoek",
    "country": "Africa/Windhoek",
  },
  {
    "offset": "UTC+02:00",
    "name": "Athens, Bucharest, Istanbul",
    "country": "Europe/Istanbul",
  },
  {
    "offset": "UTC+02:00",
    "name": "Helsinki, Kyiv, Riga",
    "country": "Europe/Kiev",
  },
  {
    "offset": "UTC+02:00",
    "name": "Cairo",
    "country": "Africa/Cairo",
  },
  {
    "offset": "UTC+02:00",
    "name": "Damascus",
    "country": "Asia/Damascus",
  },
  {
    "offset": "UTC+02:00",
    "name": "Amman",
    "country": "Asia/Amman",
  },
  {
    "offset": "UTC+02:00",
    "name": "Harare, Pretoria",
    "country": "Africa/Johannesburg",
  },
  {
    "offset": "UTC+02:00",
    "name": "Jerusalem",
    "country": "Asia/Jerusalem",
  },
  {
    "offset": "UTC+02:00",
    "name": "Beirut",
    "country": "Asia/Beirut",
  },
  {
    "offset": "UTC+03:00",
    "name": "Baghdad",
    "country": "Asia/Baghdad",
  },
  {
    "offset": "UTC+03:00",
    "name": "Minsk",
    "country": "Europe/Minsk",
  },
  {
    "offset": "UTC+03:00",
    "name": "Kuwait, Riyadh",
    "country": "Asia/Riyadh",
  },
  {
    "offset": "UTC+03:00",
    "name": "Nairobi",
    "country": "Africa/Nairobi",
  },
  {
    "offset": "UTC+03:30",
    "name": "Tehran",
    "country": "Asia/Tehran",
  },
  {
    "offset": "UTC+04:00",
    "name": "Moscow, St. Petersburg",
    "country": "Europe/Moscow",
  },
  {
    "offset": "UTC+04:00",
    "name": "Tbilisi",
    "country": "Asia/Tbilisi",
  },
  {
    "offset": "UTC+04:00",
    "name": "Yerevan",
    "country": "Asia/Yerevan",
  },
  {
    "offset": "UTC+04:00",
    "name": "Abu Dhabi, Muscat",
    "country": "Asia/Dubai",
  },
  {
    "offset": "UTC+04:00",
    "name": "Baku",
    "country": "Asia/Baku",
  },
  {
    "offset": "UTC+04:00",
    "name": "Port Louis",
    "country": "Indian/Mauritius",
  },
  {
    "offset": "UTC+04:30",
    "name": "Kabul",
    "country": "Asia/Kabul",
  },
  {
    "offset": "UTC+05:00",
    "name": "Tashkent",
    "country": "Asia/Tashkent",
  },
  {
    "offset": "UTC+05:00",
    "name": "Islamabad, Karachi",
    "country": "Asia/Karachi",
  },
  {
    "offset": "UTC+05:30",
    "name": "Sri Jayewardenepura Kotte",
    "country": "Asia/Colombo",
  },
  {
    "offset": "UTC+05:30",
    "name": "Chennai, Mumbai, New Delhi",
    "country": "Asia/Kolkata",
  },
  {
    "offset": "UTC+05:45",
    "name": "Kathmandu",
    "country": "Asia/Kathmandu",
  },
  {
    "offset": "UTC+06:00",
    "name": "Astana",
    "country": "Asia/Almaty",
  },
  {
    "offset": "UTC+06:00",
    "name": "Dhaka",
    "country": "Asia/Dhaka",
  },
  {
    "offset": "UTC+06:00",
    "name": "Yekaterinburg",
    "country": "Asia/Yekaterinburg",
  },
  {
    "offset": "UTC+06:30",
    "name": "Yangon",
    "country": "Asia/Yangon",
  },
  {
    "offset": "UTC+07:00",
    "name": "Bangkok, Hanoi, Jakarta",
    "country": "Asia/Bangkok",
  },
  {
    "offset": "UTC+07:00",
    "name": "Novosibirsk",
    "country": "Asia/Novosibirsk",
  },
  {
    "offset": "UTC+08:00",
    "name": "Krasnoyarsk",
    "country": "Asia/Krasnoyarsk",
  },
  {
    "offset": "UTC+08:00",
    "name": "Ulaanbaatar",
    "country": "Asia/Ulaanbaatar",
  },
  {
    "offset": "UTC+08:00",
    "name": "Beijing, Chongqing, Hong Kong",
    "country": "Asia/Shanghai",
  },
  {
    "offset": "UTC+08:00",
    "name": "Perth",
    "country": "Australia/Perth",
  },
  {
    "offset": "UTC+08:00",
    "name": "Kuala Lumpur, Singapore",
    "country": "Asia/Singapore",
  },
  {
    "offset": "UTC+08:00",
    "name": "Taipei",
    "country": "Asia/Taipei",
  },
  {
    "offset": "UTC+09:00",
    "name": "Irkutsk",
    "country": "Asia/Irkutsk",
  },
  {
    "offset": "UTC+09:00",
    "name": "Seoul",
    "country": "Asia/Seoul",
  },
  {
    "offset": "UTC+09:00",
    "name": "Osaka, Sapporo, Tokyo",
    "country": "Asia/Tokyo",
  },
  {
    "offset": "UTC+09:30",
    "name": "Darwin",
    "country": "Australia/Darwin",
  },
  {
    "offset": "UTC+09:30",
    "name": "Adelaide",
    "country": "Australia/Adelaide",
  },
  {
    "offset": "UTC+10:00",
    "name": "Hobart",
    "country": "Australia/Hobart",
  },
  {
    "offset": "UTC+10:00",
    "name": "Yakutsk",
    "country": "Asia/Yakutsk",
  },
  {
    "offset": "UTC+10:00",
    "name": "Brisbane",
    "country": "Australia/Brisbane",
  },
  {
    "offset": "UTC+10:00",
    "name": "Guam, Port Moresby",
    "country": "Pacific/Port_Moresby",
  },
  {
    "offset": "UTC+10:00",
    "name": "Canberra, Melbourne, Sydney",
    "country": "Australia/Sydney",
  },
  {
    "offset": "UTC+11:00",
    "name": "Vladivostok",
    "country": "Asia/Vladivostok",
  },
  {
    "offset": "UTC+11:00",
    "name": "Solomon Islands, New Caledonia",
    "country": "Pacific/Guadalcanal",
  },
  {
    "offset": "UTC+12:00",
    "name": "Coordinated Universal Time+12",
    "country": "Etc/GMT-12",
  },
  {
    "offset": "UTC+12:00",
    "name": "Fiji, Marshall Islands",
    "country": "Pacific/Fiji",
  },
  {
    "offset": "UTC+12:00",
    "name": "Magadan",
    "country": "Asia/Magadan",
  },
  {
    "offset": "UTC+12:00",
    "name": "Auckland, Wellington",
    "country": "Pacific/Auckland",
  },
  {
    "offset": "UTC+13:00",
    "name": "Nuku'alofa",
    "country": "Pacific/Tongatapu",
  },
  {
    "offset": "UTC+13:00",
    "name": "Samoa",
    "country": "Pacific/Apia",
  },
];